<template>
  <div class="bg">

    <Nav @getTime="getTime" title="实时客流"/>
    <div id="container" style="width: 100%;height: 77%;margin: 10px 0;position: relative;">
      <!-- 底部图表容器 -->
      <div class="bottom-chart-box">
        <div class="chart-container">
          <div class="chart-item">
            <div class="chart-title backGround-line">实时日客流</div>
            <div id="realtimeChart" style="width: 100%;height: 90%;"></div>
            <div style="display: flex;justify-content: center">
              <el-button :disabled="setCarringCapacity" @click="setSumbit">{{ task }}</el-button>
              <el-input placeholder="输入日承载量" v-model="dayCarringCapacity" v-if="!setCarringCapacity"></el-input>
            </div>
          </div>
          <div class="chart-item">
            <div class="chart-title backGround-line">
              <div>客流趋势</div>
            </div>
            <div id="passengerFlow" style="width: 100%;height: 90%;"></div>
          </div>
          <div class="chart-item">
              <div class="chart-title backGround-line">累计时客流</div>
              <div id="totalChart" style="width: 100%;height: 90%;"></div>
              <div style="display: flex;justify-content: center">
                <el-button :disabled="setCarringCapacityHour" @click="setSumbitHour">{{ taskHour }}</el-button>
                <el-input placeholder="输入时承载量" v-model="dayCarringCapacityHour" v-if="!setCarringCapacityHour"></el-input>
              </div>
          </div>
        </div>

      </div>

      <div class="container-child">
        <div>
          <el-select @change="changePlace" v-model="selectedItem" :value-key="'id'" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.label"
                :value="item">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <ruleTime :selected-date="new Date(form.date)" @time-slot-click="handleTimeClick"></ruleTime>
  </div>
</template>
<script>
import Nav from '_c/Nav/Nav.vue'
import AMapLoader from '@amap/amap-jsapi-loader';
import * as echarts from 'echarts'
import ruleTime from "@/components/ruleTime/ruleTime.vue";
import {
  touristFlowGetPoiList,
  touristFlowGetTouristsFlowLine,
  touristFlowGetTouristsFlowHourHeat,
  touristFlowGetTouristFlowDayHeat,
  touristFlowSetDayCarringCapacity,
  touristFlowSetHourCarringCapacity
} from '@/request/passengerFlow/passengerFlow'

window._AMapSecurityConfig = {
  securityJsCode: "79e3d194f4e6b4a2f3bd4f851a3d3306",
};
export default {
  components: {Nav, ruleTime},
  data() {
    return {
      loading: false,
      selectedItem: null, // 双向绑定select
      form: {      // 存参数
        date: null
      },
      location: {},  // 存储经纬度，选择时间段查看位置
      options: [],  //各个景点
      value: '',   // 绑定到el-select
      chart_1: '', // 实时客流折线图
      chart_2: '', // 实时承载量
      chart_3: '', // 日承载量
      heatMap: null,
      map: null,
      geocoder: null,// 地理编码
      Marker: null,//
      dailyCarryingCapacity:'' ,// 每次加载获取的日承载量
      setCarringCapacity:true ,// 编辑按钮开启关闭
      setCarringCapacityHour:true, // 时承载量开启关闭
      dayCarringCapacity:'' ,// 用户选的日承载量
      dayCarringCapacityHour:'',// 用户选的时承载量
      task:'编辑', // 编辑按钮打开后要变成提交
      taskHour:'编辑', // 编辑按钮打开后时承载量按钮变成提交

    }
  },

  mounted() {
    this.$nextTick(async () => {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await AMapLoader.load({
        key: 'ef49373644dc51e28ef64fae992c51cf',
        version: '2.0',
        plugins: ["AMap.Geocoder", "AMap.HeatMap", 'AMap.Scale', 'AMap.ToolBar', 'AMap.HawkEye', 'AMap.MapType', 'AMap.Geolocation', 'AMap.Polygon','AMap.ControlBar','AMap.ToolBar']
      }).then((AMap) => {
        this.map = new AMap.Map('container', {
          zoom: 5,
          viewMode: '3D', //开启3D视图,默认为关闭
          rotateEnable: false,
          pitchEnable: true,
          terrain: true, // 开启地形图

          // mapStyle: "amap://styles/dark", //设置地图的显示样式
          center: [116.333926, 39.997245]
        });
        this.Marker = new AMap.Marker()
        this.geocoder = new AMap.Geocoder({
          city: "全国", // 默认城市，可以根据需要更改
        });

        var controlBar = new AMap.ControlBar({//控制地图旋转插件
          position: {
            right: '150px',
            top: '20px'
          }
        });
        this.map.addControl(controlBar);
        this.map.addControl(new AMap.Scale())    //地图控件
        this.map.addControl(new AMap.ToolBar())
        this.map.addControl(new AMap.HawkEye())
        this.map.addControl(new AMap.MapType())
        this.map.addControl(new AMap.Geolocation())
      }).catch((err) => {
        console.log(err)
      })
      loading.close();
    })
  },
  methods: {
    // 选择景点后
    async changePlace(value) {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.form.poiId = value.id
      this.location.lat = value.lat
      this.location.lng = value.lng
      this.chart_1 = echarts.init(document.getElementById('passengerFlow'));
      this.chart_2 = echarts.init(document.getElementById('totalChart'));
      this.chart_3 = echarts.init(document.getElementById('realtimeChart'));
      //获取客流折线图
      await touristFlowGetTouristsFlowLine(this.form).then(res => {
        const seriesData = res.data.data.map(item => item.count)
        const xAxisList = res.data.data.map(item => item.hour)
        this.chart_1.setOption({
          title: {
            text: "单位：个", // 主标题文本，支持使用 \n 换行
            textStyle: {
              color: "#808080", // 主标题文字的颜色
              fontSize: 12 // 主标题文字的字体大小
            },
            left: "20", // title 组件离容器左侧的距离
            top: "20" // title 组件离容器上侧的距离
          },
          tooltip: {
            trigger: 'axis',
            formatter: '{c}个' // 提示框浮层内容格式器
          },
          xAxis: {
            type: 'category',
            data: xAxisList,
            axisLabel: {
              // 坐标轴字体颜色
              color: "#808080",
              fontSize: 10
            },
            axisLine: {
              show: false, // 是否显示
            },
            axisTick: { // y轴刻度线
              show: false // 是否显示
            },
            splitLine: { // 网格
              show: false // 是否显示
            },
          },
          yAxis: {
            min: 0,
            nameTextStyle: {
              color: '#808080',
              fontSize: 12,
            },
            axisLabel: {
              // 坐标轴字体颜色
              color: "#808080",
              fontSize: 12
            },
            axisLine: {
              show: false
            },
            axisTick: {
              // y轴刻度线
              show: false
            },
            splitLine: { // 网格
              show: true, // 是否显示
              lineStyle: {
                color: 'rgba(0,0,0,0.15)', // 颜色
              }
            }
          },

          series: [
            {
              type: 'line',
              symbolSize: 10,
              z: 1,
              label: {
                show: true, // 线条折点处显示值
                position: 'top', // 标签的位置
                color: "#808080", // 文字颜色
                fontSize: 12, // 文字像素
              },
              itemStyle: {
                color: '#325DEC' // 图形的颜色
              },
              lineStyle: {
                color: '#325DEC', // 线的颜色
                width: 1, // 线的宽度
              },
              data: seriesData, // 数据
            }
          ]
        })
        loading.close();
      })
      // 获取日承载量
      await touristFlowGetTouristFlowDayHeat(this.form).then(res=>{
        this.dailyCarryingCapacity  = res.data.data.flowCount
        this.chart_3.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            formatter: "{b} : {c}"
          },
          toolbox: {
            show: true,
            feature: {}
          },
          series: [
            {
              name: '累计客流',
              // 移除或调整splitNumber（刻度分割数），避免因无最大值导致刻度过多
              splitNumber: 10,  // 减少刻度数量，避免视觉混乱
              type: 'gauge',
              radius: '100%',
              max: 10000,
              center: ['50%', '55%'],
              detail: {
                formatter: '{value}',
                fontSize: 8,
                color: '#fff'
              },
              axisLine: {
                lineStyle: {
                  // 颜色数组的比例值（如0.167）将基于实际value自动适配
                  color: [[0.167, '#393c39'], [0.334, '#3c3c23'], [0.5, '#473019'], [0.667, '#ff7373'], [1, '#af7373']]
                }
              },
              axisLabel: {
                textStyle: {
                  fontWeight: 'bolder',
                  color: '#fff',
                  shadowColor: '#fff',
                  shadowBlur: 10
                }
              },
              title: {
                textStyle: {
                  fontWeight: 'bolder',
                  fontSize: 8,
                  fontStyle: 'italic',
                  color: '#fff'
                }
              },
              data: [{value: res.data.data.flowCount, name: '累计客流'}]
            }
          ]
        })
      })
      this.setCarringCapacity = false // 开启日承载量配置
      this.task = '提交'
    },
    // 选择时间刻度尺后
    async handleTimeClick(hour) {
      if (!this.form.poiId) return
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.form.hour = hour
      await  touristFlowGetTouristsFlowHourHeat(this.form).then(res => {
        // 替换掉最大的时承载量
        this.dailyCarryingCapacity = res.data.data.totalFlowCount
        // 选择时间刻度尺后触发日承载量
        this.chart_2.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            formatter: "{b} : {c}"
          },
          toolbox: {
            show: true,
            feature: {}
          },
          series: [
            {
              name: '累计客流',
              // 移除或调整splitNumber（刻度分割数），避免因无最大值导致刻度过多
              splitNumber: 1,  // 减少刻度数量，避免视觉混乱
              type: 'gauge',
              radius: '100%',
              max: Math.floor(res.data.data.totalFlowCount),
              center: ['50%', '55%'],
              detail: {
                formatter: '{value}',
                fontSize: 8,
                color: '#fff'
              },
              axisLine: {
                lineStyle: {
                  // 颜色数组的比例值（如0.167）将基于实际value自动适配
                  color: [[0.167, '#393c39'], [0.334, '#3c3c23'], [0.5, '#473019'], [0.667, '#ff7373'], [1, '#af7373']]
                }
              },
              axisLabel: {
                textStyle: {
                  fontWeight: 'bolder',
                  color: '#fff',
                  shadowColor: '#fff',
                  shadowBlur: 10
                }
              },
              title: {
                textStyle: {
                  fontWeight: 'bolder',
                  fontSize: 8,
                  fontStyle: 'italic',
                  color: '#fff'
                }
              },
              data: [{value: res.data.data.flowCount, name: '累计客流'}]
            }
          ]
        })
        const heatmapData = res.data.data.heatData;
        if (!this.geocoder) {
          console.error('Geocoder 未初始化');
          return;
        }
        try {
          if (this.heatMap) {
            this.heatMap.setMap(null); // 先解除与地图的关联
            this.heatMap = null; // 释放引用
          }
          // var polygon = new window.AMap.Polygon({
          //   path: [
          //     new window.AMap.LngLat(116.46, 39.93),
          //     new window.AMap.LngLat(116.44, 39.91),
          //     new window.AMap.LngLat(116.49, 32),
          //     new window.AMap.LngLat(87.49, 32)
          //   ]
          // });
          // this.map.add([polygon])
          // 2. 清除地图上所有热力图层（确保无残留）
          this.map.getAllOverlays('heatmap').forEach(overlay => {
            this.map.remove(overlay);
          });
          // 3. 重新设置地图中心
          this.map.setCenter([this.location.lng, this.location.lat]);
          this.map.setZoom(15);
          // 4. 创建全新的热力图实例
          this.heatMap = new window.AMap.HeatMap(this.map, {
            radius: 20,
            opacity: [0, 0.8]
          });
          // 6. 设置新的热力图数据


          this.heatMap.setDataSet({
            data: heatmapData,
            max: 100
          });

          // loading.close();  // 加载完后取消
        } catch (error) {
          console.error("发生错误:", error);
        }
        loading.close();
      })
      this.setCarringCapacityHour = false
      this.taskHour = '提交'
      // 处理点击逻辑
    },
    // 提交日承载量
    setSumbit(){
      this.form.num = this.dayCarringCapacity
      if(this.form.num > 10000){
        this.$message.warning('实时预警:最大不超过10000！');
        return;
      }
      touristFlowSetDayCarringCapacity(this.form).then(res => {
        if(res.data.code == 1){
          this.$message.success('配置成功');
          this.chart_3.setOption({
            backgroundColor: 'transparent',
            tooltip: {
              formatter: "{b} : {c}"
            },
            toolbox: {
              show: true,
              feature: {}
            },
            series: [
              {
                name: '累计客流',
                // 移除或调整splitNumber（刻度分割数），避免因无最大值导致刻度过多
                splitNumber: 10,  // 减少刻度数量，避免视觉混乱
                type: 'gauge',
                radius: '100%',
                max: 10000,
                center: ['50%', '55%'],
                detail: {
                  formatter: '{value}',
                  fontSize: 8,
                  color: '#fff'
                },
                axisLine: {
                  lineStyle: {
                    // 颜色数组的比例值（如0.167）将基于实际value自动适配
                    color: [[0.167, '#393c39'], [0.334, '#3c3c23'], [0.5, '#473019'], [0.667, '#ff7373'], [1, '#af7373']]
                  }
                },
                axisLabel: {
                  textStyle: {
                    fontWeight: 'bolder',
                    color: '#fff',
                    shadowColor: '#fff',
                    shadowBlur: 10
                  }
                },
                title: {
                  textStyle: {
                    fontWeight: 'bolder',
                    fontSize: 8,
                    fontStyle: 'italic',
                    color: '#fff'
                  }
                },
                data: [{value: this.form.num,  name: '累计客流'}]
              }
            ]
          })

          this.dayCarringCapacity = ''
        }
      })
    },
    // 提交时承载量
    setSumbitHour(){
      this.form.num = this.dayCarringCapacityHour
      if(this.form.num > this.dailyCarryingCapacity){
        this.$message.warning('实时预警:时承载量不的超日承载量');
        return
      }
      touristFlowSetHourCarringCapacity(this.form).then((res) => {
        if(res.data.code == 1){
          this.$message.success('配置成功');
          this.chart_2.setOption({
            backgroundColor: 'transparent',
            tooltip: {
              formatter: "{b} : {c}"
            },
            toolbox: {
              show: true,
              feature: {}
            },
            series: [
              {
                name: '累计客流',
                // 移除或调整splitNumber（刻度分割数），避免因无最大值导致刻度过多
                splitNumber: 1,  // 减少刻度数量，避免视觉混乱
                type: 'gauge',
                radius: '100%',
                max: Math.floor(this.dailyCarryingCapacity),
                center: ['50%', '55%'],
                detail: {
                  formatter: '{value}',
                  fontSize: 8,
                  color: '#fff'
                },
                axisLine: {
                  lineStyle: {
                    // 颜色数组的比例值（如0.167）将基于实际value自动适配
                    color: [[0.167, '#393c39'], [0.334, '#3c3c23'], [0.5, '#473019'], [0.667, '#ff7373'], [1, '#af7373']]
                  }
                },
                axisLabel: {
                  textStyle: {
                    fontWeight: 'bolder',
                    color: '#fff',
                    shadowColor: '#fff',
                    shadowBlur: 10
                  }
                },
                title: {
                  textStyle: {
                    fontWeight: 'bolder',
                    fontSize: 8,
                    fontStyle: 'italic',
                    color: '#fff'
                  }
                },
                data: [{value: this.form.num, name: '累计客流'}]
              }
            ]
          })
          console.log(111111)
          this.dayCarringCapacityHour = ''
        }
      })
    },
    getTime(value) {
      this.form.date = value;
      if(this.form.poiId){
        //获取客流折线图
         touristFlowGetTouristsFlowLine(this.form).then(res => {
          const seriesData = res.data.data.map(item => item.count)
          const xAxisList = res.data.data.map(item => item.hour)
          this.chart_1.setOption({
            title: {
              text: "单位：个", // 主标题文本，支持使用 \n 换行
              textStyle: {
                color: "#808080", // 主标题文字的颜色
                fontSize: 12 // 主标题文字的字体大小
              },
              left: "20", // title 组件离容器左侧的距离
              top: "20" // title 组件离容器上侧的距离
            },
            tooltip: {
              trigger: 'axis',
              formatter: '{c}个' // 提示框浮层内容格式器
            },
            xAxis: {
              type: 'category',
              data: xAxisList,
              axisLabel: {
                // 坐标轴字体颜色
                color: "#808080",
                fontSize: 10
              },
              axisLine: {
                show: false, // 是否显示
              },
              axisTick: { // y轴刻度线
                show: false // 是否显示
              },
              splitLine: { // 网格
                show: false // 是否显示
              },
            },
            yAxis: {
              min: 0,
              nameTextStyle: {
                color: '#808080',
                fontSize: 12,
              },
              axisLabel: {
                // 坐标轴字体颜色
                color: "#808080",
                fontSize: 12
              },
              axisLine: {
                show: false
              },
              axisTick: {
                // y轴刻度线
                show: false
              },
              splitLine: { // 网格
                show: true, // 是否显示
                lineStyle: {
                  color: 'rgba(0,0,0,0.15)', // 颜色
                }
              }
            },

            series: [
              {
                type: 'line',
                symbolSize: 10,
                z: 1,
                label: {
                  show: true, // 线条折点处显示值
                  position: 'top', // 标签的位置
                  color: "#808080", // 文字颜色
                  fontSize: 12, // 文字像素
                },
                itemStyle: {
                  color: '#325DEC' // 图形的颜色
                },
                lineStyle: {
                  color: '#325DEC', // 线的颜色
                  width: 1, // 线的宽度
                },
                data: seriesData, // 数据
              }
            ]
          })
        })
        // 获取日承载量
         touristFlowGetTouristFlowDayHeat(this.form).then(res=>{
          this.dailyCarryingCapacity  = res.data.data.flowCount
          this.chart_3.setOption({
            backgroundColor: 'transparent',
            tooltip: {
              formatter: "{b} : {c}"
            },
            toolbox: {
              show: true,
              feature: {}
            },
            series: [
              {
                name: '累计客流',
                // 移除或调整splitNumber（刻度分割数），避免因无最大值导致刻度过多
                splitNumber: 10,  // 减少刻度数量，避免视觉混乱
                type: 'gauge',
                radius: '100%',
                max: 10000,
                center: ['50%', '55%'],
                detail: {
                  formatter: '{value}',
                  fontSize: 8,
                  color: '#fff'
                },
                axisLine: {
                  lineStyle: {
                    // 颜色数组的比例值（如0.167）将基于实际value自动适配
                    color: [[0.167, '#393c39'], [0.334, '#3c3c23'], [0.5, '#473019'], [0.667, '#ff7373'], [1, '#af7373']]
                  }
                },
                axisLabel: {
                  textStyle: {
                    fontWeight: 'bolder',
                    color: '#fff',
                    shadowColor: '#fff',
                    shadowBlur: 10
                  }
                },
                title: {
                  textStyle: {
                    fontWeight: 'bolder',
                    fontSize: 8,
                    fontStyle: 'italic',
                    color: '#fff'
                  }
                },
                data: [{value: res.data.data.flowCount, name: '累计客流'}]
              }
            ]
          })
        })
      }
    },
  },
  created() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // 月份从0开始，所以要加1
    const day = today.getDate();
    this.form.date = (year + '-' + month + '-' + day)
    this.$nextTick(() => {
      // 默认加载的景点
      touristFlowGetPoiList().then(res => {
        this.options = res.data.data.map(item => ({
          id: item.id,
          value: item.id,
          label: item.name,
          lng: item.lng,
          lat: item.lat,
        }))
      })
    })
  },

}
</script>


<style scoped lang="scss">


.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
  box-sizing: border-box;
  /* 关键修改：包含内边距到尺寸计算中 */
  overflow-y: auto;
  /* 隐藏超出部分 */
}

#container {
  position: relative;
}

.container-child {
  position: absolute;
  top: 10%; // 垂直居中
  right: 20%; // 距离右边30px
  //transform: translateY(-50%);  // 精准垂直居中
  z-index: 9; // 确保在地图之上

  .el-select {
    width: 200px; // 增大宽度
    font-size: 16px; // 增大字体
    background-color: #ffffffcc; // 半透明白色背景
    border-radius: 8px; // 圆角
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); // 阴影
    transition: all 0.3s ease;
    margin-left: 10px;

    ::v-deep.el-select .el-input__inner {
      //margin-left: 10px !important;
    }

    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3); // 悬停阴影加强
    }

    :deep(.el-select-dropdown__item){
      color: black;
    }
    .el-input__inner {
      background-color: transparent; // 内部输入框透明
      color: #333; // 深色文字
      border: none; // 移除默认边框
    }

    .el-select-dropdown {
      background-color: #ffffffcc; // 下拉菜单半透明
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .el-select-dropdown__item {
      font-size: 15px;
      padding: 10px 20px;

      &:hover {
        background-color: #e6f7ff; // 悬停颜色
      }
    }
  }
}


.bottom-chart-box {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 45%;
  background-color: rgba(19, 25, 47, 0.9);
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 10px;
  box-sizing: border-box;
}

.chart-container {
  display: flex;
  height: 100%;
  gap: 20px;
}

.chart-item {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  .chart-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #fff;
    text-align: center;
  }
}


</style>
